import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "./AuthContext";

const BusinessCtx = createContext(null);

export function BusinessProvider({ children }) {
  const { user, kind } = useAuth();
  const [businesses, setBusinesses] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("crm_active_biz") || null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user || kind !== "user") return;
    setLoading(true);
    api.get("/businesses").then((r) => {
      setBusinesses(r.data);
      if (r.data.length && !activeId) {
        setActiveId(r.data[0].id);
        localStorage.setItem("crm_active_biz", r.data[0].id);
      }
    }).finally(() => setLoading(false));
  }, [user, kind]);

  const switchBusiness = (id) => {
    setActiveId(id);
    localStorage.setItem("crm_active_biz", id);
  };

  const refresh = async () => {
    const r = await api.get("/businesses");
    setBusinesses(r.data);
  };

  const activeBusiness = businesses.find((b) => b.id === activeId);

  return (
    <BusinessCtx.Provider value={{ businesses, activeId, activeBusiness, switchBusiness, refresh, loading }}>
      {children}
    </BusinessCtx.Provider>
  );
}

export const useBusiness = () => useContext(BusinessCtx);
